// extracted by mini-css-extract-plugin
export var author = "Author-module--author--2kT-Q";
export var author__bio_twitter = "Author-module--author__bio_twitter--1Lwix";